/* AUTO-GENERATED by scripts/generate-icon-font.mjs — do not edit by hand.
   Regenerate with `pnpm icons:build` after changing PJ_ICON. */
import type { PjIconName } from '@/domains/pjazza/components/atoms/pj-icon/PjIcon.types.ts'

/** The character that draws each icon in the Pjazza Symbols font. */
const PJ_ICON_GLYPH: Record<PjIconName, string> = {
  add: '\u{e145}',
  arrow_back: '\u{e5c4}',
  business_center: '\u{eb3f}',
  cake: '\u{e7e9}',
  calendar_month: '\u{ebcc}',
  check: '\u{e668}',
  close: '\u{e5cd}',
  diamond: '\u{ead5}',
  dining: '\u{eff4}',
  edit_note: '\u{e745}',
  expand_more: '\u{e5cf}',
  favorite: '\u{e87e}',
  group: '\u{ea21}',
  info: '\u{e88e}',
  location_on: '\u{f1db}',
  logout: '\u{e9ba}',
  person: '\u{f0d3}',
  qr_code_scanner: '\u{f206}',
  receipt_long: '\u{ef6e}',
  remove: '\u{e15b}',
  schedule: '\u{efd6}',
  search: '\u{ef7a}',
  shopping_bag: '\u{f1cc}'
}

export { PJ_ICON_GLYPH }
